// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a7c19924","89":"f9f91efa","375":"6c5c6d68","606":"f2bf4940","619":"e64131ac","787":"91bd498a","811":"d38e5f97","891":"35c75295"}[chunkId] + ".chunk.js";
};